<template>
  <div class="list">
      <div v-if="classifyConfig && classifyConfig.length > 0">
            <div class="list-item" v-for="(item,index) in classifyConfig" :key="index"  @click="ToClassify(item)">
                <img class="list-icon" :src="item.Icon" />
                <div class="list-desc border_b" :class="index == classifyConfig.length-1 ? 'bottom-none':'' ">
                    <div class="desc">
                        <div class="desc-title">{{item.Name}}</div>
                        <div class="desc-detail" v-if="item.Desc">{{item.Desc}}</div>
                    </div>
                </div>
            </div>
    </div>
      <div class="first-load" v-else>
         <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {api} from './../util/api.js'
import Bus from '../components/bus.js'
import {getCookie,changeTitle} from './../util/tool.js'
import moreSelectConfig from './../util/productIds.js'
export default {
    data(){
        return{
            classifyConfig:[]
        }
    },
     watch:{
        $route(to,from){
            // if(from.path.indexOf('classify') >= 0 && to.path.indexOf('index') >= 0){
            //     debugger
            //     changeTitle("我的订单")
            // }
        }
    },
    mounted() {
        //请求过滤的列表
        let wxuser = getCookie('WxUser');
        let params = {
            openId: this.spliteWxUser(wxuser,'openid'),
            unionid: this.spliteWxUser(wxuser,'unionid')
        }
        axios.get(api.GetFilterPageProducts , {
            params:params,
        }).then((res)=>{
            if(res.data && res.data.Body && res.data.Body.Products && res.data.Body.Products.length !== 0) {
                let productIds = [...res.data.Body.Products]
                this.classifyConfig =  productIds ;
            }else{
               this.classifyConfig =  moreSelectConfig; 
            }
        }).catch((error)=>{
            
            this.classifyConfig =  moreSelectConfig;
        })
        changeTitle('分类查找订单')
        
    },
     methods:{
            //拿cookie WxUser中的openid
        spliteWxUser:function(rStr,str){
            try{
                let a = rStr.split("&");
                for (let i in a)
                    if (a[i].indexOf(str + "=") >= 0) {
                        let n = a[i].split("=");
                        if (null != n[1])
                            return n[1]
                    }
                return ""
            }
            catch(e){
            }
            return ''
        },
        ToClassify(item){
            let type = item.ID
            this.$router.push(`/list/${type}?name=${decodeURIComponent(item.Name)}`);
            changeTitle(item.Name)
            Bus.$emit('fromIndexToNow',{type:type,name:item.Name})
            AppendTrack(category, action, label, '^分类选项^' + item.Name + '^');
        }
     }
}
</script>

<style lang="scss" scoped>
    .border, .border_t, .border_r, .border_b, .border_l {
        border-image: none;
        border: solid 0 #e4e4e4;
    }

@media (-webkit-min-device-pixel-ratio: 2) {
    .border, .border_t, .border_r, .border_b, .border_l {
        border-width: 0;
        border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAH0lEQVQIW2O8c+fOfwYsgBEkoaKiwogsBxKjtgQ2ywFMJyV5rQbuRgAAAABJRU5ErkJggg==) 2 2 stretch;
    }
}

.border {
    border-width: 1px;
}

.border_t {
    border-top-width: 1px;
}

.border_r {
    border-right-width: 1px;
}

.border_b {
    border-bottom-width: 1px;
}

.border_l {
    border-left-width: 1px;
}
    .list-item{
        height: 100%;
        width: 100%;
        background: #edf0f7;
    }
    .list-item{
        width: 100%;
        display: -webkit-box;
        height: 1.4rem;
        background: #fff;
    }
    .list-icon{
        width: 0.6rem;
        height: 0.6rem;
        margin-left: 0.4rem;
        margin-right: 0.4rem;
    }
    .list-desc{
        -webkit-box-flex: 1;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: justify;
        border-bottom: 1px solid #e4e4e4;
        text-align:left;
    }
    .bottom-none{
        border-bottom: 0;
    }
    .desc-title{
        font-size: 0.36rem;
        height: 0.36rem;
        line-height: 0.40rem;
        font-weight: bold;
        color: #333;
        // border:1px solid red;
    }
    .desc-detail{
        font-size: 0.24rem;
         height: 0.24rem;
        line-height: 0.24rem;
        color: #999;
        margin-top: 0.16rem;
        // border:1px solid red;
    }
    .first-load {
        width: 100%;
        margin: 4rem auto 0;
        text-align: center;
    }

    .first-load img {
        width: 0.6rem;
    }
</style>
    


// WEBPACK FOOTER //
// src/page/classifylist.vue